module.exports = __webpack_public_path__ + "img/ic_image.27e3cd69.svg";